module.exports = __webpack_public_path__ + "static/img/577_phase_function_Paper_PointsHejduk_Prediction.66caceb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/577_phase_function_Paper_PointsHejduk_Prediction.png
// module id = AsEm
// module chunks = 0